import {
  API_ERR_CODE_DISPLAY_ENUM,
  API_ERR_CODE_ENUM,
  ERR_MSG_NOT_LOGIN,
  ERR_MSG_UNKNOWN,
  INFER_TASK_STATUS_ENUM,
  SUCCESS_CODE_API,
} from "./constants";

/**
 *
 * @param promptText
 * @returns
 */
export const errHandling = (promptText: string) => {
  let errMsg = promptText;
  const code = promptText.split(": ")[0];

  if (
    promptText === API_ERR_CODE_DISPLAY_ENUM.unauthorized ||
    parseInt(code) === API_ERR_CODE_ENUM.unauthorized
  ) {
    // 401: Unauthorized
    window.location.href = "/aigc/portal/";
    errMsg = API_ERR_CODE_DISPLAY_ENUM.unauthorized;
  }

  if (parseInt(code) === API_ERR_CODE_ENUM.noSuchBackgroundRequest) {
    // 4: no such background request.
    errMsg = API_ERR_CODE_DISPLAY_ENUM.noSuchBackgroundRequest;
  }

  // 413: Request Entity Too Large
  if (parseInt(code) === API_ERR_CODE_ENUM.requestEntityTooLarge) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.requestEntityTooLarge;
  }

  // 5: task a241ef337ab7987d has been canceled
  if (parseInt(code) === API_ERR_CODE_ENUM.taskCanceled) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.taskCanceled;
  }

  // 1: infer server unavailable
  if (parseInt(code) === API_ERR_CODE_ENUM.inferServerUnavailable) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.inferServerUnavailable;
  }

  // 404: Not Found
  if (parseInt(code) === API_ERR_CODE_ENUM.notFound) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.notFound;
  }

  // 500: Internal Server Error
  if (parseInt(code) === API_ERR_CODE_ENUM.internalServerError) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.internalServerError;
  }

  // 3: magic point not enough
  if (parseInt(code) === API_ERR_CODE_ENUM.notEnoughPoint) {
    errMsg = API_ERR_CODE_DISPLAY_ENUM.notEnoughPoint;
  }

  return errMsg;
};

/**
 *
 * @returns
 */
export const getTokenFromSearchParams = () => {
  let token: string | null = null;

  const address = decodeURIComponent(window.location.href);
  // console.log("-> getTokenFromSearchParams, address:", address);

  if (!address.includes("portal/")) {
    const newAddress = address.replace("portal", "portal/");
    window.location.href = newAddress;
  }

  if (address.includes("token")) {
    const idx = address.indexOf("?");
    const str = address.substring(idx);
    const searchParams = new URLSearchParams(str);
    /*console.log(
      "-> getTokenFromSearchParams, searchParams:",
      searchParams.toString()
    );*/
    token = searchParams.get("token");
  }

  return token;
};

/**
 *
 * @param response
 * @returns
 */
export const handleResponseReturnJSON = (response: Response) => {
  if (response.ok) {
    return response.json();
  } else {
    console.log(
      "-> httpUtil-handleResponseReturnJSON, response.status:",
      response.status,
      ", response.statusText:",
      response.statusText
    );
    return {
      errCode: response.status,
      errMsg: response.statusText,
    };
  }
};

// "/aigc/api/payment/open"
export type PayAPIRequestBodyType = {
  amount: number;
};

// new /aigc/api/infer/replace_with_reference
// new /aigc/api/infer/replace_any
// disused /aigc/api/infer/image
export type MagicAPIRequestBodyType = {
  init_image?: string;
  mask_image?: string;
  reference_image?: string;
  text_prompt?: string;
  enhance?: boolean;
  app_type?: "focus_edit";
  width?: number;
  height?: number;
};

// "/aigc/api/infer/segment_any"
export type SegmentAnyAPIRequestBodyType = {
  init_image: string | ArrayBuffer;
  segment_prompt: string;
  prompt: string;
  return_base64?: boolean; // optional
};

/**
 *
 * @param api
 * @param requestBody
 * @param onPostFetchData
 * @param onPostFetchCatchErr
 * @param onWithoutAuth
 */
export const postFetch = (
  api: string,
  requestBody:
    | PayAPIRequestBodyType
    | MagicAPIRequestBodyType
    | SegmentAnyAPIRequestBodyType,
  onPostFetchData: (data: any, type: string | undefined) => void,
  onPostFetchCatchErr: (err: any) => void,
  onWithoutAuth: () => void
) => {
  console.log(" -> httpUtil-postFetch, api:", api);
  console.log(" -> httpUtil-postFetch, requestBody:", requestBody);

  const token = getTokenFromSearchParams();

  if (token) {
    const headers = new Headers();
    headers.set("authorization", `bearer ${token}`);
    headers.set("content-type", "application/json");

    const segmentType = (requestBody as SegmentAnyAPIRequestBodyType)
      .segment_prompt;

    fetch(api, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    })
      .then((response) => handleResponseReturnJSON(response))
      .then((data) =>
        segmentType
          ? onPostFetchData(data, segmentType)
          : onPostFetchData(data, undefined)
      )
      .catch((err) => onPostFetchCatchErr(err));
  } else {
    onWithoutAuth();
  }
};

/**
 *
 * @param api
 * @param onGetFetchData
 * @param onGetFetchCatchErr
 * @param onWithoutAuth
 */
export const getFetch = (
  api: string,
  onGetFetchData: (data: any) => void,
  onGetFetchCatchErr: (err: any) => void,
  onWithoutAuth: () => void
) => {
  // "/aigc/api/user/info"
  // `/aigc/api/payment/state?tradeid=${tradeID}`
  console.log(" -> httpUtil-getFetch, api:", api);

  const token = getTokenFromSearchParams();

  if (token) {
    const headers = new Headers();
    headers.set("authorization", `bearer ${token}`);
    headers.set("content-type", "application/json");

    fetch(api, {
      method: "GET",
      headers: headers,
    })
      .then((response) => handleResponseReturnJSON(response))
      .then((data) => onGetFetchData(data))
      .catch((err) => onGetFetchCatchErr(err));
  } else {
    onWithoutAuth();
  }
};

export const getFetchWithoutToken = (
  api: string,
  onGetFetchData: (data: any) => void,
  onGetFetchCatchErr: (err: any) => void
) => {
  // "/aigc/api/user/info"
  // `/aigc/api/payment/state?tradeid=${tradeID}`
  console.log(" -> httpUtil-getFetchWithoutToken, api:", api);

  const headers = new Headers();
  headers.set("content-type", "application/json");

  fetch(api, {
    method: "GET",
    headers: headers,
  })
    .then((response) => handleResponseReturnJSON(response))
    .then((data) => onGetFetchData(data))
    .catch((err) => onGetFetchCatchErr(err));
};

/**
 *
 * @param api
 * @param reqBody
 * @returns
 */
export async function getTaskId(
  api: string,
  reqBody: MagicAPIRequestBodyType | SegmentAnyAPIRequestBodyType
) {
  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = {
    "content-type": "application/json",
    authorization: `bearer ${token}`,
  };

  const response = await fetch(api, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(reqBody),
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getTaskId, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getTaskId, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  // { code: 0, msg: "ok", tid: "123456abcde" }
  return respJSON;
}

/**
 *
 * @param tid
 * @param onWithoutAuth
 * @returns
 */
export async function getTaskStatus(tid: string) {
  const api = `/aigc/api/async/infer/${tid}/state`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = new Headers();
  headers.set("authorization", `bearer ${token}`);
  headers.set("content-type", "application/json");

  const response = await fetch(api, {
    method: "GET",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getTaskStatus, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getTaskStatus, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  // {code: 0, msg: "ok", tid: "tid you give", index: 0, "state": "waiting" | "in progress" | "down" | "failed"}
  return respJSON;
}

/**
 *
 * @param tid
 * @returns
 */
export async function getTaskResult(tid: string) {
  const api = `/aigc/api/async/infer/${tid}/result`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = {
    "content-type": "application/json",
    authorization: `bearer ${token}`,
  };

  const response = await fetch(api, {
    method: "GET",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getTaskResult, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getTaskResult, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  return respJSON;
}

/**
 *
 * @param ms
 * @returns
 */
function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 *
 * @param api
 * @param reqBody
 * @returns
 */
export async function getTaskResultEvery3s(
  api: string,
  reqBody: MagicAPIRequestBodyType | SegmentAnyAPIRequestBodyType,
  onTaskIdUpdate: (tid: string) => void,
  onTaskStatusUpdate: (status: string, tIdx: number) => void
) {
  console.log(
    "-> httpUtil-getTaskResultEvery3s, api:",
    api,
    ", request:",
    reqBody
  );

  try {
    const respGetTaskId = await getTaskId(api, reqBody);
    const tid = respGetTaskId?.tid;

    if (typeof tid === "string") {
      onTaskIdUpdate(tid);

      while (true) {
        const respGetTaskStatus = await getTaskStatus(tid);
        const taskState = respGetTaskStatus?.state;
        const taskIdx = respGetTaskStatus?.index;

        if (typeof taskState === "string" && typeof taskIdx === "number") {
          onTaskStatusUpdate(taskState, taskIdx);

          if (
            taskState === INFER_TASK_STATUS_ENUM.down ||
            taskState === INFER_TASK_STATUS_ENUM.failed ||
            taskState === INFER_TASK_STATUS_ENUM.canceled
          ) {
            break;
          }
        } else {
          return respGetTaskStatus;
        }

        await sleep(3000);
      }

      const respTaskResult = await getTaskResult(tid);
      return respTaskResult;
    } else {
      return respGetTaskId;
    }
  } catch (e) {
    return `${ERR_MSG_UNKNOWN}: ${e}`;
  }
}

/**
 *
 * @param tid
 * @returns
 */
export async function cancelTask(tid: string) {
  const api = `/aigc/api/async/infer/${tid}/cancel`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = {
    authorization: `bearer ${token}`,
  };

  const response = await fetch(api, {
    method: "POST",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-cancelTask, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-cancelTask, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  return respJSON;
}

/**
 *
 * @param tid
 * @returns
 */
export async function deleteTask(tid: string) {
  // DELETE /aigc/api/gallery/history/{tid}
  const api = `/aigc/api/gallery/history/${tid}`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = {
    authorization: `bearer ${token}`,
  };

  const response = await fetch(api, {
    method: "DELETE",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-deleteTask, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-deleteTask, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  return respJSON;
}

/**
 *
 * @param tid
 * @returns
 */
export async function getTaskDetails(tid: string) {
  // GET /aigc/api/gallery/detail/{tid}
  const api = `/aigc/api/gallery/detail/${tid}`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = {
    authorization: `bearer ${token}`,
  };

  const response = await fetch(api, {
    method: "GET",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getTaskDetails, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getTaskDetails, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  return respJSON;
}

/**
 *
 * @param start
 * @param count
 * @returns
 */
export async function getGalleryHistory(start: number, count: number) {
  // GET /aigc/api/gallery/history?start=0&count=10
  const api = `/aigc/api/gallery/history`;

  const searchParams = new URLSearchParams();
  searchParams.set("start", start.toString());
  searchParams.set("count", count.toString());

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = new Headers();
  headers.set("authorization", `bearer ${token}`);
  headers.set("content-type", "application/json");

  const response = await fetch(api, {
    method: "GET",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getGalleryHistory, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getGalleryHistory, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  // {code: 0, data: {count: 10, history:[{ctime: "2025-07-09 12:09:34", request: {init_image: ""}, response: {}, state: "down", tid: "", type: "replace any", utime: "2025-07-09 12:09:34"}, ...], start: 0, total: 100}, msg: "ok"}
  return respJSON;
}

/**
 *
 * @returns
 */
export async function getMainPageBanner() {
  // GET /aigc/api/main/banner
  const api = `/aigc/api/main/banner`;

  const token = getTokenFromSearchParams();
  if (!token) {
    return ERR_MSG_NOT_LOGIN;
  }

  const headers = new Headers();
  headers.set("authorization", `bearer ${token}`);
  headers.set("content-type", "application/json");

  const response = await fetch(api, {
    method: "GET",
    headers: headers,
  });

  if (response.status !== 200) {
    const errMsg = `${response.status}: ${response.statusText}`;
    console.log(" -> httpUtil-getMainPageBanner, errMsg:", errMsg);
    return errMsg;
  }

  const respJSON = await response.json();
  console.log(" -> httpUtil-getMainPageBanner, response json:", respJSON);
  if (respJSON?.code !== SUCCESS_CODE_API) {
    return `${respJSON?.code}: ${respJSON?.msg}`;
  }

  return respJSON;
}
